import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { provideValueAccessor } from 'studio-components/shared/value-accessor.utils';

@Component({
  selector: 'studio-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [provideValueAccessor(() => CheckboxComponent)],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() uniqueId: string;
  @Input() disabled: boolean;
  @Input() checked: boolean;
  @Output() valueChanged = new EventEmitter<boolean>();

  handleChange(input: HTMLInputElement) {
    this.valueChanged.emit(input.checked);

    this.onChange(input.checked);
    this.onTouched();
  }

  // Reactive form
  writeValue(checked: boolean) {
    this.checked = checked;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  onChange = (_: boolean) => {};
  onTouched = () => {};

  registerOnChange(fn: () => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }
}
